import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Clock, Video, Wallet } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function CadouHero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-brand-cream" data-id="element-294">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-brand-gold/[0.08] to-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/4 animate-float pointer-events-none" data-id="element-295" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-296">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 gap-x-12 lg:gap-20 lg:items-center" data-id="element-297">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-1 lg:order-1 lg:col-start-1 lg:row-start-1 max-w-2xl flex flex-col items-center text-center" data-id="element-298">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-gold text-white text-sm font-bold tracking-wider uppercase mb-8 shadow-warm" data-id="element-299">
              <Gift className="w-4 h-4" data-id="element-300" />
              Sesiune Cadou de Evaluare
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-[64px] leading-[1.1] font-bold text-brand-text mb-6 text-balance" data-id="element-301">
              Claritate în 30 de minute: descoperă ce te blochează și care e
              următorul tău pas
            </h1>

            <p className="font-subtitle font-medium text-xl md:text-2xl text-brand-textSec leading-relaxed text-balance" data-id="element-302">
              O sesiune gratuită online, în care vorbim despre ce simți că nu
              merge în viața ta, identificăm împreună ce te ține pe loc și
              stabilim primul pas concret pe care îl poți face. Fără vânzare.
              Fără presiune. Doar claritate și ghidare.
            </p>

            {/* Session details badges */}
            <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-303">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-brand-text/10 text-brand-text text-sm font-medium shadow-sm" data-id="element-304">
                <Clock className="w-4 h-4 text-brand-gold" data-id="element-305" />
                30 de minute
              </div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-brand-text/10 text-brand-text text-sm font-medium shadow-sm" data-id="element-306">
                <Video className="w-4 h-4 text-brand-gold" data-id="element-307" />
                Online pe Zoom
              </div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-50 border border-green-200 text-green-700 text-sm font-bold shadow-sm" data-id="element-308">
                <Wallet className="w-4 h-4" data-id="element-309" />
                GRATUIT
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-2 lg:order-2 lg:col-start-2 lg:row-start-1 lg:row-span-2 relative w-full aspect-[4/5] max-w-[420px] mx-auto lg:ml-auto" data-id="element-310">
            <div className="absolute inset-0 bg-brand-gold/30 rounded-[32px] blur-2xl transform translate-x-4 translate-y-4" data-id="element-311" />
            <div className="absolute -top-12 -right-12 w-48 h-48 border-[1.5px] border-brand-gold/40 rounded-full border-b-transparent border-l-transparent rotate-45 -z-10" data-id="element-312" />

            <div className="relative w-full h-full rounded-[32px] shadow-warm overflow-hidden border-4 border-white" data-id="element-313">
              <img src="https://cdn.magicpatterns.com/uploads/1rkWgruLABLbiu4kcbCtdt/73.png" alt="Adrian Huniade" className="w-full h-full object-cover object-top" data-id="element-314" />
            </div>

            {/* Floating gift badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.5,
            rotate: -10
          }} animate={{
            opacity: 1,
            scale: 1,
            rotate: -8
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="absolute -top-6 -left-6 bg-white rounded-2xl px-4 py-3 shadow-warm border-2 border-brand-gold flex items-center gap-2" data-id="element-315">
              <Gift className="w-6 h-6 text-brand-gold" data-id="element-316" />
              <div className="text-left" data-id="element-317">
                <div className="text-xs text-brand-textSec font-medium uppercase tracking-wider" data-id="element-318">
                  Cadou
                </div>
                <div className="font-heading font-bold text-brand-text text-sm" data-id="element-319">
                  Pentru tine
                </div>
              </div>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="order-3 lg:order-3 lg:col-start-1 lg:row-start-2 max-w-2xl flex flex-col items-center text-center" data-id="element-320">
            <CTAButton data-id="element-321" />
          </motion.div>
        </div>
      </div>
    </section>;
}